

export enum ViewMode {
    DualPage = 'DualPage',
    DualPageWithCover = 'DualPageWithCover',
    SinglePage = 'SinglePage',
}
